import {ComparisonSlider} from '@sdox/ui'

import type {XcNwBlock_BlockMediaComparisonSliderType_Fragment} from '@sdox/api'

export const BlockMediaComparisonSlider = ({
  image1,
  image2,
}: XcNwBlock_BlockMediaComparisonSliderType_Fragment) => {
  return <ComparisonSlider images={[image1.thumbnailUrl, image2.thumbnailUrl]} />
}
